'use client';
import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { ElasticVehicleServiceHistory } from '@//app/api/search/vehicles/[id]';
import { Alert } from '@//components/Alert';
import { Checklist } from '@//components/Checklist';

interface ServiceProps {
  serviceHistory: ElasticVehicleServiceHistory | null;
}

export const Service: React.FC<ServiceProps> = ({ serviceHistory }) => {
  const t = useTranslations('pages.item.moreInformationSection.service');

  if (!serviceHistory || !serviceHistory.isServiceHistoryAvailable) {
    return (
      <Alert id="serivce-no-information" variant="info">
        {t('noServiceHistory')}
      </Alert>
    );
  }

  return (
    <>
      {serviceHistory.isServicePlanFollowed ? (
        <Checklist items={[t('planFollowed')]} />
      ) : (
        <Checklist items={[t('planNotFollowed')]} icon={<X />} />
      )}
    </>
  );
};
